@if (isLinked) {
  <oui-icon class="primary-icon">link</oui-icon>
}
